import "scripts/templates/collection.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.collection");
